import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppFilter } from '../../../models/app-filter.model';
import { AbGestaoPreCadastros } from 'app/abstract/full-pages/gestao-pre-cadastros/gestao-pre-cadastros.abstract';

@Injectable({ providedIn: 'root' })
export class GestaoPreCadastrosService extends AbGestaoPreCadastros {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public getPreCadastros(filter: AppFilter) {
    return this.get(`admin/pre_cadastro/filter/${filter.encode()}`);
  }

  public getExistsAguardando() {
    return this.get(`admin/pre_cadastro/exists_aguardando`);
  }
}
